import React from 'react';
import { Props } from 'recharts/types/component/Label';

const UNITS_TO_REMOVE = 10;
export const BarChartCustomLeftLabel: React.FC<Readonly<Props>> = ({
  x,
  y,
  value,
  fontSize,
  color,
}) => {
  const labelHeightPosition = Number(y) - UNITS_TO_REMOVE;

  return (
    <text
      x={x}
      y={labelHeightPosition}
      fill={color}
      fontSize={fontSize || 12}
      textAnchor="start"
      style={{
        textTransform: 'capitalize',
      }}
    >
      {value}
    </text>
  );
};
